
import { FormGroup, FormControl, FormArray, Validators } from '@angular/forms';


export function getUpdateProjectHouseSideDtoFormGroup() {
return new FormGroup({
    sideIndex: new FormControl<number | undefined>(undefined),
    sideLabel: new FormControl<string | undefined>(undefined),
    minHeightInM: new FormControl<number | undefined>(undefined),
    maxHeightInM: new FormControl<number | undefined>(undefined),
    widthInM: new FormControl<number | undefined>(undefined),
    hasDormers: new FormControl<boolean | undefined>(false),
    dormerLengthInM: new FormControl<number | undefined>(undefined),
    towerNumber: new FormControl<number | undefined>(undefined),
    hasSolarPanels: new FormControl<boolean | undefined>(false),
    hasRoofOverhang: new FormControl<boolean | undefined>(false),
    calculatedAreaInSqm: new FormControl<number | undefined>(undefined),
    baseAreaInSqm: new FormControl<number | undefined>(undefined),
    notes: new FormControl<string | undefined>(undefined),
    active: new FormControl<boolean | undefined>(undefined),
})
;
}
      